"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAlphaPortfolioAmount = getAlphaPortfolioAmount;
exports.getAlphaPortfolioAmountInUSD = getAlphaPortfolioAmountInUSD;
exports.getPortfolioAmount = getPortfolioAmount;
exports.getDoubleAssetPortfolioAmountInUSD = getDoubleAssetPortfolioAmountInUSD;
exports.getNaviLoopingPoolDebt = getNaviLoopingPoolDebt;
exports.getSingleAssetPortfolioAmount = getSingleAssetPortfolioAmount;
exports.getSingleAssetPortfolioAmountInUSD = getSingleAssetPortfolioAmountInUSD;
exports.getTokenBalance = getTokenBalance;
const tslib_1 = require("tslib");
const decimal_js_1 = require("decimal.js");
const index_js_1 = require("../../index.js");
const getReceipts_js_1 = require("./getReceipts.js");
const coins_js_1 = require("../../common/coins.js");
const maps_js_1 = require("../../common/maps.js");
const prices_js_1 = require("../../utils/clmm/prices.js");
const prices_js_2 = require("../../utils/prices.js");
const cetus_sui_clmm_sdk_1 = require("@cetusprotocol/cetus-sui-clmm-sdk");
const bn_js_1 = tslib_1.__importDefault(require("bn.js"));
const stsui_sdk_1 = require("@alphafi/stsui-sdk");
async function getAlphaPortfolioAmount(poolName, options, ignoreCache) {
    const receipts = await (0, getReceipts_js_1.getReceipts)(poolName, options.address, ignoreCache);
    const pool = await (0, getReceipts_js_1.getPool)(poolName, ignoreCache);
    if (!pool) {
        throw new Error("Pool not found");
    }
    const exchangeRate = await (0, getReceipts_js_1.getPoolExchangeRate)(poolName, ignoreCache);
    let totalXTokens = new decimal_js_1.Decimal(0);
    if (!exchangeRate) {
        return "0"; // if pool has 0 xtokens
    }
    if (options.isLocked === true) {
        receipts.forEach(async (receipt) => {
            const xTokens = new decimal_js_1.Decimal(receipt.content.fields.xTokenBalance);
            const bal = new decimal_js_1.Decimal(Number(receipt.content.fields.unlocked_xtokens) *
                exchangeRate.toNumber());
            totalXTokens = totalXTokens.add(xTokens.sub(bal));
        });
    }
    else if (options.isLocked === false) {
        receipts.forEach((receipt) => {
            const bal = new decimal_js_1.Decimal(Number(receipt.content.fields.unlocked_xtokens) *
                exchangeRate.toNumber());
            totalXTokens = totalXTokens.add(bal);
        });
    }
    else {
        receipts.forEach((receipt) => {
            const xTokens = receipt.content.fields.xTokenBalance;
            totalXTokens = totalXTokens.add(xTokens);
        });
    }
    if (totalXTokens.gt(0)) {
        const poolExchangeRate = await (0, getReceipts_js_1.getPoolExchangeRate)(poolName, ignoreCache);
        if (poolExchangeRate) {
            const tokens = totalXTokens.div(1e9).mul(poolExchangeRate);
            return `${tokens}`;
        }
        else {
            console.error(`Could not get poolExchangeRate for poolName: ${poolName}`);
        }
    }
    else {
        return "0";
    }
}
async function getAlphaPortfolioAmountInUSD(poolName, options, ignoreCache) {
    const tokens = await getAlphaPortfolioAmount(poolName, options, ignoreCache);
    const priceOfAlpha = await (0, prices_js_1.getAlphaPrice)();
    if (priceOfAlpha && tokens) {
        let amount = new decimal_js_1.Decimal(tokens);
        amount = amount.mul(priceOfAlpha);
        return amount.toString();
    }
}
async function getPortfolioAmount(poolName, address, ignoreCache) {
    let portfolioAmount = ["0", "0"];
    let totalXTokens = new decimal_js_1.Decimal(0);
    if (poolName.toString().includes("-FUNGIBLE-")) {
        const tokenBalance = await getTokenBalance(index_js_1.poolInfo[poolName].receiptName, address);
        if (tokenBalance) {
            totalXTokens = new decimal_js_1.Decimal(tokenBalance);
        }
        else {
            console.error("could not fetch fungible token balance for getPortfolioAmount");
        }
    }
    else {
        const receipts = await (0, getReceipts_js_1.getReceipts)(poolName, address, ignoreCache);
        if (receipts && receipts.length > 0) {
            let xTokens = receipts[0].content.fields.xTokenBalance;
            if (poolName === "BLUEFIN-LYF-STSUI-SUI") {
                let investor = (await (0, getReceipts_js_1.getInvestor)(poolName, true));
                xTokens = new decimal_js_1.Decimal(xTokens)
                    .mul(new decimal_js_1.Decimal(1).minus(new decimal_js_1.Decimal(investor.content.fields.current_debt_to_supply_ratio.fields.value).div(1e18)))
                    .toString();
            }
            totalXTokens = totalXTokens.add(xTokens);
        }
    }
    if (totalXTokens.gt(0)) {
        const poolExchangeRate = await (0, getReceipts_js_1.getPoolExchangeRate)(poolName, ignoreCache);
        if (poolExchangeRate) {
            const tokens = totalXTokens.mul(poolExchangeRate);
            const poolTokenAmounts = await (0, index_js_1.getCoinAmountsFromLiquidity)(poolName, tokens.toString(), ignoreCache);
            portfolioAmount = poolTokenAmounts;
        }
        else {
            console.error(`Could not get poolExchangeRate for poolName: ${poolName}`);
        }
    }
    return portfolioAmount;
}
async function getDoubleAssetPortfolioAmountInUSD(poolName, address, ignoreCache) {
    if (index_js_1.poolInfo[poolName].assetTypes.length === 2) {
        const amounts = await getPortfolioAmount(poolName, address, ignoreCache);
        if (amounts) {
            const ten = new decimal_js_1.Decimal(10);
            const pool1 = maps_js_1.doubleAssetPoolCoinMap[poolName].coin1;
            const pool2 = maps_js_1.doubleAssetPoolCoinMap[poolName].coin2;
            const amount0 = new decimal_js_1.Decimal(amounts[0]).div(ten.pow(coins_js_1.coinsList[pool1].expo));
            const amount1 = new decimal_js_1.Decimal(amounts[1]).div(ten.pow(coins_js_1.coinsList[pool2].expo));
            const [priceOfCoin0, priceOfCoin1] = await (0, prices_js_2.getLatestPrices)([`${pool1}/USD`, `${pool2}/USD`], ignoreCache);
            const amount = amount0.mul(priceOfCoin0).add(amount1.mul(priceOfCoin1));
            return amount.toString();
        }
        else {
            console.error(`getPortfolioAmountInUSD is not implemented for poolName: ${poolName}`);
        }
        return "0";
    }
}
async function getNaviLoopingPoolDebt(poolName) {
    const debt = (await (0, index_js_1.getSuiClient)().getDynamicFieldObject({
        parentId: index_js_1.poolInfo[poolName].investorId,
        name: {
            type: "vector<u8>",
            value: "debt".split("").map((char) => char.charCodeAt(0)),
        },
    })).data.content.fields.value.toString();
    return debt;
}
async function getSingleAssetPortfolioAmount(poolName, address, ignoreCache) {
    let portfolioAmount = 0;
    const receipts = await (0, getReceipts_js_1.getReceipts)(poolName, address, ignoreCache);
    let totalXTokens = new decimal_js_1.Decimal(0);
    if (receipts) {
        receipts.forEach((receipt) => {
            const xTokens = receipt.content.fields.xTokenBalance;
            totalXTokens = totalXTokens.add(xTokens);
        });
    }
    if (totalXTokens.gt(0)) {
        let pool;
        let investor;
        if (index_js_1.poolInfo[poolName].parentProtocolName == "NAVI" ||
            index_js_1.poolInfo[poolName].parentProtocolName === "ALPHALEND") {
            pool = await (0, getReceipts_js_1.getPool)(poolName, ignoreCache);
            investor = (await (0, getReceipts_js_1.getInvestor)(poolName, ignoreCache));
        }
        if (poolName == "NAVI-LOOP-USDC-USDT" ||
            poolName == "NAVI-LOOP-USDT-USDC") {
            const supplyCoin = index_js_1.loopingPoolCoinMap[poolName].supplyCoin;
            const borrowCoin = index_js_1.loopingPoolCoinMap[poolName].borrowCoin;
            if (pool && investor) {
                let tokensInvested = new decimal_js_1.Decimal(0);
                const currentDebt = await getNaviLoopingPoolDebt(poolName);
                const currentSupply = investor.content.fields.tokensDeposited.toString();
                if (index_js_1.cetusPoolMap[supplyCoin + "-" + borrowCoin] &&
                    currentDebt &&
                    currentSupply) {
                    const cetusPool = await (0, index_js_1.getParentPool)(supplyCoin + "-" + borrowCoin, ignoreCache);
                    if (cetusPool) {
                        const sqrtPrice = cetusPool?.content.fields.current_sqrt_price;
                        const price = cetus_sui_clmm_sdk_1.TickMath.sqrtPriceX64ToPrice(new bn_js_1.default(sqrtPrice), coins_js_1.coinsList[supplyCoin].expo, coins_js_1.coinsList[borrowCoin].expo);
                        const currentDebtInSupplyCoin = new decimal_js_1.Decimal(currentDebt).div(price);
                        tokensInvested = new decimal_js_1.Decimal(currentSupply).minus(currentDebtInSupplyCoin);
                    }
                    else {
                        console.error(`couldnt fetch cetus pool`);
                    }
                }
                else if (index_js_1.cetusPoolMap[borrowCoin + "-" + supplyCoin] &&
                    currentDebt !== undefined &&
                    currentSupply !== undefined) {
                    const cetusPool = await (0, index_js_1.getParentPool)(borrowCoin + "-" + supplyCoin, ignoreCache);
                    if (cetusPool) {
                        const sqrtPrice = cetusPool?.content.fields.current_sqrt_price;
                        const price = cetus_sui_clmm_sdk_1.TickMath.sqrtPriceX64ToPrice(new bn_js_1.default(sqrtPrice), coins_js_1.coinsList[borrowCoin].expo, coins_js_1.coinsList[supplyCoin].expo);
                        const currentDebtInSupplyCoin = new decimal_js_1.Decimal(currentDebt).mul(price);
                        tokensInvested = new decimal_js_1.Decimal(currentSupply).minus(currentDebtInSupplyCoin);
                    }
                    else {
                        console.error(`couldnt fetch cetus pool`);
                    }
                }
                else {
                    console.error(`one or more of these are possibly undefined: currentDebt:${currentDebt}, currentSupply: ${currentSupply}, cetusPoolMap[supplyCoin+'-'+borrowCoin]:${index_js_1.cetusPoolMap[supplyCoin + "-" + borrowCoin]}, cetusPoolMap[borrowCoin+'-'+supplyCoin]: ${index_js_1.cetusPoolMap[borrowCoin + "-" + supplyCoin]}`);
                }
                const xTokenSupplyInPool = new decimal_js_1.Decimal(pool.content.fields.xTokenSupply);
                const userTokens = totalXTokens
                    .mul(tokensInvested)
                    .div(xTokenSupplyInPool);
                const tokens = userTokens.div(Math.pow(10, 9 - coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].expo));
                portfolioAmount = Number(tokens);
            }
            else {
                console.error(`Could not get object for poolName: ${poolName}`);
            }
        }
        else if (poolName == "NAVI-LOOP-HASUI-SUI" ||
            poolName == "NAVI-LOOP-SUI-VSUI" ||
            poolName === "ALPHALEND-LOOP-SUI-STSUI" ||
            poolName === "ALPHALEND-SINGLE-LOOP-TBTC" ||
            poolName === "ALPHALEND-SINGLE-LOOP-SUIBTC" ||
            poolName === "ALPHALEND-SINGLE-LOOP-XAUM") {
            if (pool && investor) {
                const liquidity = new decimal_js_1.Decimal(investor.content.fields.tokensDeposited);
                const debtToSupplyRatio = new decimal_js_1.Decimal(investor.content.fields.current_debt_to_supply_ratio);
                const tokensInvested = liquidity.mul(new decimal_js_1.Decimal(1).minus(new decimal_js_1.Decimal(debtToSupplyRatio).div(1e20)));
                const xTokenSupplyInPool = new decimal_js_1.Decimal(pool.content.fields.xTokenSupply);
                const userTokens = totalXTokens
                    .mul(tokensInvested)
                    .div(xTokenSupplyInPool);
                let tokens = userTokens;
                if (index_js_1.poolInfo[poolName].parentProtocolName === "NAVI") {
                    tokens = userTokens.div(Math.pow(10, 9 - coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].expo));
                }
                if (poolName == "NAVI-LOOP-SUI-VSUI") {
                    // const { SevenKGateway } = await import("../");
                    // const sevenKInstance = new SevenKGateway();
                    // const numberOfTokensInSui = (await sevenKInstance.getQuote({
                    //   slippage: 1,
                    //   senderAddress: options.address,
                    //   pair: { coinA: coins["VSUI"], coinB: coins["SUI"] },
                    //   inAmount: new BN(tokens.toNumber()),
                    // })) as QuoteResponse;
                    const voloExchRate = await (0, getReceipts_js_1.fetchVoloExchangeRate)(false);
                    portfolioAmount = Number(tokens.mul(parseFloat(voloExchRate.data.exchangeRate)));
                }
                else if (poolName == "ALPHALEND-LOOP-SUI-STSUI") {
                    // const { SevenKGateway } = await import("../");
                    // const sevenKInstance = new SevenKGateway();
                    // const numberOfTokensInSui = (await sevenKInstance.getQuote({
                    //   slippage: 1,
                    //   senderAddress: options.address,
                    //   pair: { coinA: coins["VSUI"], coinB: coins["SUI"] },
                    //   inAmount: new BN(tokens.toNumber()),
                    // })) as QuoteResponse;
                    const suiTostSuiExchangeRate = await (0, stsui_sdk_1.stSuiExchangeRate)((0, stsui_sdk_1.getConf)().LST_INFO, ignoreCache);
                    portfolioAmount = Number(tokens.mul(parseFloat(suiTostSuiExchangeRate)));
                }
                else {
                    portfolioAmount = Number(tokens);
                }
            }
            else {
                console.error(`Could not get object for poolName: ${poolName}`);
            }
        }
        else {
            const poolExchangeRate = await (0, getReceipts_js_1.getPoolExchangeRate)(poolName, ignoreCache);
            if (poolExchangeRate) {
                let tokens = totalXTokens.mul(poolExchangeRate);
                if (index_js_1.poolInfo[poolName].parentProtocolName == "NAVI") {
                    tokens = tokens.div(Math.pow(10, 9 - coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].expo));
                }
                portfolioAmount = tokens.toNumber();
            }
            else {
                console.error(`Could not get poolExchangeRate for poolName: ${poolName}`);
            }
        }
    }
    return portfolioAmount;
}
async function getSingleAssetPortfolioAmountInUSD(poolName, address, ignoreCache) {
    const amounts = await getSingleAssetPortfolioAmount(poolName, address, ignoreCache);
    if (amounts !== undefined) {
        let coinName = maps_js_1.singleAssetPoolCoinMap[poolName].coin;
        if (poolName == "NAVI-LOOP-SUI-VSUI" ||
            poolName === "ALPHALEND-LOOP-SUI-STSUI") {
            coinName = "SUI";
        }
        const amount = new decimal_js_1.Decimal(amounts).div(new decimal_js_1.Decimal(Math.pow(10, coins_js_1.coinsList[coinName].expo)));
        const [priceOfCoin] = await (0, prices_js_2.getLatestPrices)([`${coinName}/USD`], ignoreCache);
        if (priceOfCoin) {
            const amountInUSD = amount.mul(priceOfCoin);
            return amountInUSD.toString();
        }
    }
    else {
        console.error(`getSingleAssetPortfolioAmountInUSD is not implemented for poolName: ${poolName}`);
    }
    return "0";
}
async function getTokenBalance(tokenName, address) {
    const suiClient = (0, index_js_1.getSuiClient)();
    let balance = "0";
    try {
        const coinBalance = await suiClient.getBalance({
            owner: address,
            coinType: coins_js_1.coinsList[tokenName].type,
        });
        const balanceInt = parseInt(coinBalance.totalBalance);
        balance = `${balanceInt}`;
        return balance;
    }
    catch {
        console.error(`Could not get Balance for token: ${tokenName}`);
    }
}
//# sourceMappingURL=getPortfolioAmounts.js.map